import { DeviceTask } from '@era/device-task-management-sdk';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export type DeviceScheduledTasksState = EntityState<DeviceTask>;

export function selectScheduledTaskId(scheduledTask: DeviceTask) {
  return scheduledTask.messageId;
}

export const adapter: EntityAdapter<DeviceTask> = createEntityAdapter<DeviceTask>({
  selectId: selectScheduledTaskId,
});

export const initialState: DeviceScheduledTasksState = adapter.getInitialState();
